import { isString, sanitizeStringForUrl } from '@grandvisionhq/utils';
import { getUrl } from '../../../../utils/get-url.js';

function createGraphSubCategoryBreadcrumb(categoryRoute, brand, page, variant, productType) {
    var ref;
    let subCategoryProperty = brand;
    if (productType === 'Accessories') {
        subCategoryProperty = variant.accessoryType;
    }
    var ref1;
    // Get the path of the route (in BR preview you also get some querystring that we don't need to create the subcategory link)
    const categoryRoutePath = (ref1 = (ref = categoryRoute === null || categoryRoute === void 0 ? void 0 : categoryRoute.split('?')) === null || ref === void 0 ? void 0 : ref[0]) !== null && ref1 !== void 0 ? ref1 : '';
    return isString(subCategoryProperty) && subCategoryProperty !== '' ? {
        name: subCategoryProperty,
        url: getUrl(`${categoryRoutePath}/${encodeURIComponent(sanitizeStringForUrl(subCategoryProperty))}`, page)
    } : null;
}

export { createGraphSubCategoryBreadcrumb };
//# sourceMappingURL=create-graph-subcategory-breadcrumb.js.map
